import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import hasInterface from '../../../../hasInterface';
import Collection from '../../../../java/util/Collection';
import Noder from './Noder';
import Coordinate from '../geom/Coordinate';
import NodedSegmentString from './NodedSegmentString';
import System from '../../../../java/lang/System';
import CoordinateArrays from '../geom/CoordinateArrays';
import ArrayList from '../../../../java/util/ArrayList';
var ScaledNoder = /*#__PURE__*/function () {
  function ScaledNoder() {
    _classCallCheck(this, ScaledNoder);
    ScaledNoder.constructor_.apply(this, arguments);
  }
  _createClass(ScaledNoder, [{
    key: "rescale",
    value: function rescale() {
      if (hasInterface(arguments[0], Collection)) {
        var segStrings = arguments[0];
        for (var i = segStrings.iterator(); i.hasNext();) {
          var ss = i.next();
          this.rescale(ss.getCoordinates());
        }
      } else if (arguments[0] instanceof Array) {
        var pts = arguments[0];
        for (var _i = 0; _i < pts.length; _i++) {
          pts[_i].x = pts[_i].x / this._scaleFactor + this._offsetX;
          pts[_i].y = pts[_i].y / this._scaleFactor + this._offsetY;
        }
        if (pts.length === 2 && pts[0].equals2D(pts[1])) System.out.println(pts);
      }
    }
  }, {
    key: "scale",
    value: function scale() {
      if (hasInterface(arguments[0], Collection)) {
        var segStrings = arguments[0];
        var nodedSegmentStrings = new ArrayList(segStrings.size());
        for (var i = segStrings.iterator(); i.hasNext();) {
          var ss = i.next();
          nodedSegmentStrings.add(new NodedSegmentString(this.scale(ss.getCoordinates()), ss.getData()));
        }
        return nodedSegmentStrings;
      } else if (arguments[0] instanceof Array) {
        var pts = arguments[0];
        var roundPts = new Array(pts.length).fill(null);
        for (var _i2 = 0; _i2 < pts.length; _i2++) roundPts[_i2] = new Coordinate(Math.round((pts[_i2].x - this._offsetX) * this._scaleFactor), Math.round((pts[_i2].y - this._offsetY) * this._scaleFactor), pts[_i2].getZ());
        var roundPtsNoDup = CoordinateArrays.removeRepeatedPoints(roundPts);
        return roundPtsNoDup;
      }
    }
  }, {
    key: "isIntegerPrecision",
    value: function isIntegerPrecision() {
      return this._scaleFactor === 1.0;
    }
  }, {
    key: "getNodedSubstrings",
    value: function getNodedSubstrings() {
      var splitSS = this._noder.getNodedSubstrings();
      if (this._isScaled) this.rescale(splitSS);
      return splitSS;
    }
  }, {
    key: "computeNodes",
    value: function computeNodes(inputSegStrings) {
      var intSegStrings = inputSegStrings;
      if (this._isScaled) intSegStrings = this.scale(inputSegStrings);
      this._noder.computeNodes(intSegStrings);
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Noder];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._noder = null;
      this._scaleFactor = null;
      this._offsetX = null;
      this._offsetY = null;
      this._isScaled = false;
      if (arguments.length === 2) {
        var noder = arguments[0],
          scaleFactor = arguments[1];
        ScaledNoder.constructor_.call(this, noder, scaleFactor, 0, 0);
      } else if (arguments.length === 4) {
        var _noder = arguments[0],
          _scaleFactor = arguments[1],
          offsetX = arguments[2],
          offsetY = arguments[3];
        this._noder = _noder;
        this._scaleFactor = _scaleFactor;
        this._isScaled = !this.isIntegerPrecision();
      }
    }
  }]);
  return ScaledNoder;
}();
export { ScaledNoder as default };